<template>
  <div>
    <hshead title="产品列表" bgcolor="#fff"></hshead>
    <div class="product-ul">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="product-li" v-for="(item, index) in list" :key="index">
          <div class="left-img">
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="tempImg"></van-image>
          </div>
          <div class="center-p">
            <div class="center-top">
              <div class="img-box">
                <img src="../assets/images/product/logo.png" alt />
              </div>
              <div class="this-p">
                高档套餐
                <span>×30张</span>
              </div>
            </div>
            <div class="center-pri">¥1800.00</div>
            <div class="del-pri">¥6666.00</div>
          </div>
          <div class="right-btn-box">
            <router-link to class="right-btn nobg">下架</router-link>
            <router-link to class="right-btn">编辑</router-link>
          </div>
        </div>
      </van-list>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item  to="/MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item icon="orders-o" >商品管理</van-tabbar-item>
      <van-tabbar-item icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Image, Tabbar, TabbarItem, List } from "vant";
import tempImg from "@/assets/images/product/temp.png";

export default {
  name: "productList",
  data() {
    return {
      tempImg: tempImg,
      list: [],
      active: 3,
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-image": Image,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
  .product-li {
    width: 6.94rem;
    height: 2.2rem;
    background-color: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    margin-bottom: 0.25rem;
    .left-img {
      width: 2.2rem;
    }
    .center-p {
      width: 3.37rem;
      padding-left: 0.17rem;
      padding-top: 0.4rem;
      .center-top {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.45rem;
        letter-spacing: 0rem;
        color: #333333;
        display: flex;
        .img-box {
          width: 0.32rem;
          height: 0.32rem;
          background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
            linear-gradient(#e2bebf, #e2bebf);
          background-blend-mode: normal, normal;
          border-radius: 50%;
          overflow: hidden;
          margin-top: 0.05rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .this-p {
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.45rem;
          letter-spacing: 0rem;
          color: #333333;
          margin-bottom: 0.2rem;
          span {
            color: #999999;
          }
        }
      }
      .center-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #ff3087;
        padding-left: 0.3rem;
      }
      .del-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: line-through;
        padding-left: 0.3rem;
      }
    }
    .right-btn-box {
      flex: 1;
      margin-right: 0.3rem;
      .right-btn {
        width: 1.36rem;
        height: 0.4rem;
        background-color: #00b8f5;
        border-radius: 0.2rem;
        border: solid 0.01rem #00b8f5;
        color: #ffffff;
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        line-height: 0.4rem;
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        &.nobg {
          color: #00b8f5;
          background-color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/productList.vue